module.exports = __webpack_public_path__ + "img/pr-14.c4c9f917.png";